const hype = {
  background100: '#050f0d',
  background80: '#071311',
  background75: '#0c1816',
  background70: '#081916',
  background60: '#111e1c',
  background50: '#192b28',
  textSecondary: '#caeae566',
  textTertiary: '#caeae5aa',
  textPrimaryHover: '#8FA9A5',
  primaryHover: '#374151'
};

export const colors = {
  background: hype.background80,
  foreground: '#243230',
  onSurface: hype.background80,
  muted: '#808080',
  text: '#ffffff',
  primary: '#CAEAE5',
  secondary: '#ce81d8',
  success: '#2DC24E',
  error: '#C22E2E',
  warning: '#ffa726',
  link: hype.textTertiary,
  linkHover: 'rgb(202, 234, 229)',
  transparent: 'transparent',
  border: 'rgba(202, 234, 229, 0.1)',
  neutral: 'rgba(255, 255, 255, 0.15)',
  tooltip: hype.background50,
  white85: 'rgba(255, 255, 255, 0.85)',
  chartLine: '#caeae5',
  chartIndicatorLine: '#628c7c',
  chartUp: '#45C8E5',
  chartDown: '#A979D8',
  tableRowHover: hype.background50,
  tableStickyBg: hype.background75,
  skeleton: {
    baseColor: hype.background100,
    highlightColor: hype.background70
  },
  hype: hype
};
